import React from 'react';
import clsx from 'clsx';
import { PRINTS_BUILDER_TASTIC } from 'helpers/constants';
import { tastics } from 'frontastic/tastics';
import { TasticWrapperProps } from './types';
import { deviceVisibility } from '../../utils/device-visibility';
import { highlight } from '../../utils/highlight';
import { injectDataSources } from '../../utils/inject-datasources';
import MissingTastic from '../missing-tastic';

const TasticWrapper = ({
  data,
  params,
  searchParams,
  dataSources,
  isHighlighted,
  categories,
}: TasticWrapperProps) => {
  const Tastic = tastics[data.tasticType];

  const resolvedTasticData = dataSources ? injectDataSources(data.configuration, dataSources) : data.configuration;
  return (
    <div
      id={data?.tasticId}
      className={clsx(
        `${highlight(isHighlighted)} ${deviceVisibility(data.configuration)}`,
        data.tasticType == PRINTS_BUILDER_TASTIC ? 'h-full' : '',
      )}
    >
      {Tastic ? (
        <Tastic
          data={resolvedTasticData}
          params={params}
          searchParams={searchParams}
          categories={categories}
        />
      ) : (
        <MissingTastic data={data} />
      )}
    </div>
  );
};

export default TasticWrapper;
